// Vendors
import { sessionUtils } from '@openbank/cf-ui-architecture-core';
// Types
import { LogMethodsHandlersType } from './types/log.handlers.type';
// Utilities
import { logCustomActionResolver } from 'resolvers/log.resolver';

let SENDING = false;

const sendCustomActionEventHandler = async (description: string): Promise<void> => {
  if (sessionUtils.isUserLogged() && !SENDING) {
    SENDING = true;
    await logCustomActionResolver(description);
    SENDING = false;
  } else {
    // throw new Error(description);
  }
};

const LogHandlers = (): LogMethodsHandlersType => ({
  handleSendCustomActionEvent: (description: string) => sendCustomActionEventHandler(description),
});

export { LogHandlers };
